import styled, { css, keyframes } from 'styled-components'
import { pxToRem } from 'styles/functions'

const ring = keyframes`
  0% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.8;
  }
  100% {
    transform: translate(-50%, -50%) scale(3);
    opacity: 0;
  }
`

const topBubbles = keyframes`
  0% {
    background-position: 5% 90%, 10% 90%, 10% 90%, 15% 90%, 25% 90%, 25% 90%, 40% 90%, 55% 90%, 70% 90%;
  }
  50% {
    background-position: 0 80%, 0 20%, 10% 40%, 20% 0, 30% 30%, 22% 50%, 50% 50%, 65% 20%, 90% 30%;
  }
  100% {
    background-position: 0 70%, 0 10%, 10% 30%, 20% -10%, 30% 20%, 22% 40%, 50% 40%, 65% 10%, 90% 20%;
    background-size: 0 0, 0 0, 0 0, 0 0, 0 0, 0 0;
  }
`

const bottomBubbles = keyframes`
  0% {
    background-position: 10% -10%, 30% 10%, 55% -10%, 70% -10%, 85% -10%, 70% -10%, 70% 0;
  }
  50% {
    background-position: 0 80%, 20% 80%, 45% 60%, 60% 100%, 75% 70%, 95% 60%, 105% 0;
  }
  100% {
    background-position: 0 90%, 20% 90%, 45% 70%, 60% 110%, 75% 80%, 95% 70%, 110% 10%;
    background-size: 0 0, 0 0, 0 0, 0 0, 0 0, 0 0;
  }
`

export const SCBottomBarContainer = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: calc(${pxToRem(80)} + env(safe-area-inset-bottom, 0px));
  background: rgba(35, 35, 35, 0.75);
  display: flex;
  justify-content: center;
  align-items: flex-end;
  padding-bottom: calc(${pxToRem(10)} + env(safe-area-inset-bottom, 0px));
  z-index: 10;

  @media (min-width: 768px) and (orientation: landscape) {
    top: 0;
    right: 0;
    bottom: unset;
    left: unset;
    width: ${pxToRem(91)};
    height: 100%;
    flex-direction: column;
    justify-content: space-around;
    align-items: stretch;
    padding-bottom: 0;
  }
`

export const SCButtonsRow = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: flex-end;
  width: 100%;

  @media (min-width: 768px) and (orientation: landscape) {
    flex-direction: column;
    justify-content: space-around;
    align-items: stretch;
    height: 100%;
    width: 100%;
  }
`

export const SCButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;

  @media (min-width: 768px) and (orientation: landscape) {
    flex-direction: column;
    align-items: center;
    padding: ${pxToRem(6)} ${pxToRem(4)};
    cursor: pointer;
  }
`

interface SCButtonOptionsProps {
  $size?: 'normal' | 'large' | 'xlarge';
  $variant?: 'default' | 'info';
  $disableBubble?: boolean;
}
export const SCButtonCircle = styled.div<SCButtonOptionsProps>`
  ${({ $size }) => {
    switch ($size) {
      case 'xlarge':
        return css`
          width: ${pxToRem(70)};
          height: ${pxToRem(70)};
          background-color: ${({ theme }) =>
            theme.photobooth_button_color || theme.button_color || '#34b076'};
        `
      default:
        return css`
          width: ${pxToRem(50)};
          height: ${pxToRem(50)};
          padding-top: ${pxToRem(20)};
        `
    }
  }}

  border-radius: ${({ $variant }) => ($variant === 'info' ? '50% 50% 0 50%' : '50%')};
  display: flex;
  justify-content: center;
  align-items: center;

  @media (min-width: 768px) and (orientation: landscape) {
    width: ${pxToRem(74)};
    height: ${pxToRem(74)};
    padding-top: 0;
    flex-shrink: 0;

    svg {
      width: ${pxToRem(40)};
      height: ${pxToRem(40)};
    }
  }

  &:before,
  &:after {
    position: absolute;
    content: '';
    display: block;
    width: 140%;
    height: 100%;
    left: -20%;
    z-index: -1000;
    transition: all ease-in-out 0.5s;
    background-repeat: no-repeat;
  }

  &:before {
    display: none;
    top: -75%;
    background-image: radial-gradient(
        circle,
        ${({ theme }) => theme.photobooth_button_color || theme.button_color || '#34b076'} 20%,
        transparent 20%
      ),
      radial-gradient(
        circle,
        transparent 20%,
        ${({ theme }) => theme.photobooth_button_color || theme.button_color || '#34b076'} 20%,
        transparent 30%
      ),
      radial-gradient(
        circle,
        ${({ theme }) => theme.photobooth_button_color || theme.button_color || '#34b076'} 20%,
        transparent 20%
      ),
      radial-gradient(
        circle,
        ${({ theme }) => theme.photobooth_button_color || theme.button_color || '#34b076'} 20%,
        transparent 20%
      ),
      radial-gradient(
        circle,
        transparent 10%,
        ${({ theme }) => theme.photobooth_button_color || theme.button_color || '#34b076'} 15%,
        transparent 20%
      ),
      radial-gradient(
        circle,
        ${({ theme }) => theme.photobooth_button_color || theme.button_color || '#34b076'} 20%,
        transparent 20%
      ),
      radial-gradient(
        circle,
        ${({ theme }) => theme.photobooth_button_color || theme.button_color || '#34b076'} 20%,
        transparent 20%
      ),
      radial-gradient(
        circle,
        ${({ theme }) => theme.photobooth_button_color || theme.button_color || '#34b076'} 20%,
        transparent 20%
      ),
      radial-gradient(
        circle,
        ${({ theme }) => theme.photobooth_button_color || theme.button_color || '#34b076'} 20%,
        transparent 20%
      );
    background-size:
      10% 10%,
      20% 20%,
      15% 15%,
      20% 20%,
      18% 18%,
      10% 10%,
      15% 15%,
      10% 10%,
      18% 18%;
  }

  &:after {
    display: none;
    bottom: -75%;
    background-image: radial-gradient(
        circle,
        ${({ theme }) => theme.photobooth_button_color || theme.button_color || '#34b076'} 20%,
        transparent 20%
      ),
      radial-gradient(
        circle,
        ${({ theme }) => theme.photobooth_button_color || theme.button_color || '#34b076'} 20%,
        transparent 20%
      ),
      radial-gradient(
        circle,
        transparent 10%,
        ${({ theme }) => theme.photobooth_button_color || theme.button_color || '#34b076'} 15%,
        transparent 20%
      ),
      radial-gradient(
        circle,
        ${({ theme }) => theme.photobooth_button_color || theme.button_color || '#34b076'} 20%,
        transparent 20%
      ),
      radial-gradient(
        circle,
        ${({ theme }) => theme.photobooth_button_color || theme.button_color || '#34b076'} 20%,
        transparent 20%
      ),
      radial-gradient(
        circle,
        ${({ theme }) => theme.photobooth_button_color || theme.button_color || '#34b076'} 20%,
        transparent 20%
      ),
      radial-gradient(
        circle,
        ${({ theme }) => theme.photobooth_button_color || theme.button_color || '#34b076'} 20%,
        transparent 20%
      );
    background-size:
      15% 15%,
      20% 20%,
      18% 18%,
      20% 20%,
      15% 15%,
      10% 10%,
      20% 20%;
  }

  &:active {
    transform: scale(0.9);
    box-shadow: ${({ theme }) =>
      `0 ${pxToRem(2)} ${pxToRem(25)} ${theme.photobooth_button_color || theme.button_color || '#34b076'}33`};
  }

  ${({ $disableBubble }) =>
    !$disableBubble &&
    css`
      &.animate:before {
        display: block;
        animation: ${topBubbles} ease-in-out 0.75s forwards;
      }

      &.animate:after {
        display: block;
        animation: ${bottomBubbles} ease-in-out 0.75s forwards;
      }
    `}
`

interface SCButtonIconProps {
  $size?: 'xlarge'|'large';
  $type?: 'play'|'other';
}
export const SCButtonIcon = styled.img<SCButtonIconProps>`
  height: ${({ $size }) => ($size === 'xlarge' ? `${pxToRem(34)}` : `${pxToRem(28)}`)};
  width: auto;
  color: white;
  ${({ $type }) => ($type === 'play' ? `margin-left: ${pxToRem(5)};` : '')};

  @media (min-width: 768px) and (orientation: landscape) {
    width: auto;
    height: ${pxToRem(40)};
    margin-left: 0;
  }
`

interface SCButtonLabelProps {
  $isCenter: boolean
}

export const SCButtonLabel = styled.span<SCButtonLabelProps>`
  font-size: ${pxToRem(10)};
  color: white;
  text-align: center;
  margin-bottom: ${pxToRem(20)};
  margin-top: ${pxToRem(5)};
  font-weight: 600;
  font-family: ${({ theme }) => theme.title_font || `'Nunito', sans-serif`};
  z-index: 1;

  @media (min-width: 768px) and (orientation: landscape) {
    margin-bottom: 0;
    margin-top: ${pxToRem(4)};
    font-size: ${pxToRem(14)};
  }

  @media (min-width: 768px) and (orientation: portrait) {
    margin-bottom: ${({ $isCenter }) => ($isCenter ? `${pxToRem(20)}` : `${pxToRem(6)}`)};
  }
`

export const SCPulseRing = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease-in-out;

  &::before {
    content: '';
    border-radius: 50%;
    width: calc(100% + ${pxToRem(14)});
    height: calc(100% + ${pxToRem(14)});
    border: ${pxToRem(5)} solid
      ${({ theme }) => theme.photobooth_button_color || theme.button_color || '#34b076'};
    box-shadow: 0 0 ${pxToRem(20)}
      ${({ theme }) => `${theme.photobooth_button_color || theme.button_color || '#34b076'}80`};
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
    pointer-events: none;
    box-sizing: border-box;
  }

  &::after {
    content: '';
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: ${pxToRem(4)} solid
      ${({ theme }) => theme.photobooth_button_color || theme.button_color || '#34b076'};
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.8;
    animation: ${ring} 1.5s ease-out infinite;
    pointer-events: none;
    box-sizing: border-box;
  }

  &:hover {
    transform: translateY(-${pxToRem(4)});
  }

  &:hover::before {
    opacity: 1;
  }

  &:hover::after {
    animation: none;
    opacity: 0;
  }
`